import * as React from "react";
import { formatText } from "bernie-l10n";
import { UitkImage } from "uitk-react-images";

export const LazyLoaderPlaceHolder = (props: { name?: string }) => {
  return (
    <UitkImage alt={formatText("hotels.imagePlaceHolder", props.name)} placeholderImage={true} />
  );
};
